module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp8-d5bb570f58342018d7320998605df202.jpg";